import { createAsyncThunk } from "@reduxjs/toolkit";
import { Report } from "powerbi-client";
import { ThunkApiConfig } from "@shared/models/redux";
import { openNotificationThunk } from "@store/Notification/thunks";
import { callExportAPI } from "@reporting/store/thunks/callExportAPI";
import { ReportingExport } from "@reporting/models";
import { getExportParams } from "@portfolioPerformance/utils/getExportParams";

export const postPortfolioPerformanceExportThunk = createAsyncThunk<
  ReportingExport,
  { type: string; report: Report },
  ThunkApiConfig
>(
  "portfolioPerformance/postPortfolioPerformanceExportThunk",
  async ({ type, report }, { dispatch, rejectWithValue }) => {
    try {
      const exportParams = await getExportParams(report);

      return await dispatch(callExportAPI("PortfolioPerformance", type, JSON.stringify(exportParams)));
    } catch (error) {
      dispatch(
        openNotificationThunk({
          variant: "warning",
          text: "Failed to export report",
        })
      );

      return rejectWithValue("Failed to fetch export details");
    }
  }
);
